module.exports = function (t) {
  var e = {};

  function o(n) {
    if (e[n]) return e[n].exports;
    var r = e[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return t[n].call(r.exports, r, r.exports, o), r.l = !0, r.exports;
  }

  return o.m = t, o.c = e, o.d = function (t, e, n) {
    o.o(t, e) || Object.defineProperty(t, e, {
      enumerable: !0,
      get: n
    });
  }, o.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, o.t = function (t, e) {
    if (1 & e && (t = o(t)), 8 & e) return t;
    if (4 & e && "object" == typeof t && t && t.__esModule) return t;
    var n = Object.create(null);
    if (o.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: t
    }), 2 & e && "string" != typeof t) for (var r in t) {
      o.d(n, r, function (e) {
        return t[e];
      }.bind(null, r));
    }
    return n;
  }, o.n = function (t) {
    var e = t && t.__esModule ? function () {
      return t.default;
    } : function () {
      return t;
    };
    return o.d(e, "a", e), e;
  }, o.o = function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }, o.p = "", o(o.s = 7);
}([function (t, e, o) {
  var n = o(1),
      r = Math.sqrt(2),
      i = Math.cos,
      a = Math.max,
      u = Math.min;

  function s(t) {
    return u(t.duration, Date.now() - t.mouseDown);
  }

  function c(t) {
    return t.mouseUp > 0 ? Date.now() - t.mouseUp : 0;
  }

  function l(t) {
    var e = t.duration,
        o = t.radius,
        r = .85 * n(s(t), 0, o, e),
        u = .15 * n(c(t), 0, o, e),
        l = .02 * o * i(Date.now() / e);
    return a(0, r + u + l);
  }

  t.exports = {
    getMaxRadius: function getMaxRadius(t, e, o) {
      return u(.5 * a(t, e), o);
    },
    getBlotOpacity: function getBlotOpacity(t, e) {
      return n(c(t), e, -e, t.duration);
    },
    getBlotOuterOpacity: function getBlotOuterOpacity(t, e) {
      return u(this.getBlotOpacity(t, e), n(s(t), 0, .3, 3 * t.duration));
    },
    getBlotShiftX: function getBlotShiftX(t, e, o) {
      return u(1, l(t) / e * 2 / r) * (o / 2 - t.x);
    },
    getBlotShiftY: function getBlotShiftY(t, e, o) {
      return u(1, l(t) / e * 2 / r) * (o / 2 - t.y);
    },
    getBlotScale: function getBlotScale(t) {
      return l(t) / t.radius;
    }
  };
}, function (t, e) {
  t.exports = function (t, e, o, n) {
    return o * ((t = t / n - 1) * t * t * t * t + 1) + e;
  };
}, function (t, e, o) {
  var n = o(0),
      r = function r(t) {
    var e = t.mouseUp,
        o = t.duration;
    return !e || Date.now() - e < o;
  };

  t.exports = function (t) {
    var e = [],
        o = !1,
        i = void 0,
        a = {
      each: function each(t, o) {
        for (var n = 0, r = e.length; n < r; n++) {
          t.call(o, e[n]);
        }
      },
      play: function play() {
        o || (o = !0, a.update());
      },
      stop: function stop() {
        o = !1, cancelAnimationFrame(i);
      },
      getTotalOpacity: function getTotalOpacity(t) {
        for (var o = 0, r = 0, i = e.length; r < i; r++) {
          o += n.getBlotOuterOpacity(e[r], t);
        }

        return o;
      },
      update: function update() {
        (e = e.filter(r)).length ? i = requestAnimationFrame(a.update) : a.stop(), t();
      },
      add: function add(t) {
        e.push(t), a.play();
      },
      release: function release(t) {
        for (var o = e.length - 1; o >= 0; o--) {
          if (!e[o].mouseUp) return e[o].mouseUp = t;
        }
      }
    };
    return a;
  };
}, function (t, e) {
  t.exports = {
    borderRadius: "inherit",
    height: "100%",
    left: 0,
    position: "absolute",
    top: 0,
    width: "100%"
  };
}, function (t, e) {
  t.exports = require("react");
}, function (t, e) {
  t.exports = function (t) {
    return (window.devicePixelRatio || 1) / (t.webkitBackingStorePixelRatio || t.mozBackingStorePixelRatio || t.msBackingStorePixelRatio || t.oBackingStorePixelRatio || t.backingStorePixelRatio || 1);
  };
}, function (t, e) {
  var o = !1;
  "undefined" != typeof window && (o = "ontouchstart" in window || window.DocumentTouch && document instanceof window.DocumentTouch), t.exports = o;
}, function (t, e, o) {
  var n = Object.assign || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var o = arguments[e];

      for (var n in o) {
        Object.prototype.hasOwnProperty.call(o, n) && (t[n] = o[n]);
      }
    }

    return t;
  };

  var r = o(6),
      i = 0,
      a = o(5),
      u = o(4),
      s = o(3),
      c = o(2),
      l = 2 * Math.PI,
      p = o(0),
      f = function (t) {
    function e(o) {
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e);

      var n = function (t, e) {
        if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !e || "object" != typeof e && "function" != typeof e ? t : e;
      }(this, t.apply(this, arguments));

      return n.tick = function () {
        var t = n.state,
            e = t.ctx,
            o = t.color,
            r = t.density,
            i = t.height,
            a = t.width,
            u = t.store;
        e.save(), e.scale(r, r), e.clearRect(0, 0, a, i), e.fillStyle = o, n.props.background && (e.globalAlpha = u.getTotalOpacity(n.props.opacity), e.fillRect(0, 0, a, i)), u.each(n.makeBlot, n), e.restore();
      }, n._onPress = function (t) {
        var e = t.button,
            o = t.ctrlKey,
            r = t.clientX,
            a = t.clientY,
            u = t.changedTouches,
            s = Date.now();
        if (u) for (var c = 0; c < u.length; c++) {
          var l = u[c],
              p = l.clientX,
              f = l.clientY;
          n.pushBlot(s, p, f);
        } else e !== i || o || n.pushBlot(s, r, a);
      }, n._onRelease = function () {
        n.state.store.release(Date.now());
      }, n.state = {
        color: "transparent",
        density: 1,
        height: 0,
        store: c(n.tick),
        touchEvents: n.touchEvents(),
        width: 0
      }, n;
    }

    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
    }(e, t), e.prototype.touchEvents = function () {
      return this.props.hasTouch ? {
        onTouchStart: this._onPress,
        onTouchEnd: this._onRelease,
        onTouchCancel: this._onRelease
      } : {
        onMouseDown: this._onPress,
        onMouseUp: this._onRelease,
        onMouseLeave: this._onRelease
      };
    }, e.prototype.makeBlot = function (t) {
      var e = this.state,
          o = e.ctx,
          n = e.height,
          r = e.width,
          i = t.x,
          a = t.y,
          u = t.radius;

      if (o.globalAlpha = p.getBlotOpacity(t, this.props.opacity), o.beginPath(), this.props.recenter) {
        var s = Math.max(n, r);
        i += p.getBlotShiftX(t, s, r), a += p.getBlotShiftY(t, s, n);
      }

      o.arc(i, a, u * p.getBlotScale(t), 0, l), o.closePath(), o.fill();
    }, e.prototype.componentWillUnmount = function () {
      this.state.store.stop();
    }, e.prototype.pushBlot = function (t, e, o) {
      var n = this,
          r = this.canvas;
      r.getDOMNode && "function" == typeof r.getDOMNode && (r = r.getDOMNode());
      var i = r.getBoundingClientRect(),
          u = i.top,
          s = i.bottom,
          c = i.left,
          l = i.right,
          f = window.getComputedStyle(r).color,
          h = this.state.ctx || r.getContext("2d"),
          d = a(h),
          y = s - u,
          g = l - c,
          v = p.getMaxRadius(y, g, this.props.radius);
      this.setState({
        color: f,
        ctx: h,
        density: d,
        height: y,
        width: g
      }, function () {
        n.state.store.add({
          duration: n.props.duration,
          mouseDown: t,
          mouseUp: 0,
          radius: v,
          x: e - c,
          y: o - u
        });
      });
    }, e.prototype.setCanvas = function (t) {
      this.canvas = t;
    }, e.prototype.render = function () {
      var t = this.state,
          e = t.className,
          o = t.density,
          r = t.height,
          i = t.width,
          a = t.touchEvents;
      return u.createElement("canvas", n({
        className: e,
        ref: this.setCanvas.bind(this),
        style: n({}, s, this.props.style),
        height: r * o,
        width: i * o,
        onDragOver: this._onRelease
      }, a));
    }, e;
  }(u.PureComponent);

  f.defaultProps = {
    background: !0,
    className: "ink",
    duration: 1e3,
    opacity: .25,
    radius: 150,
    recenter: !0,
    hasTouch: r
  }, t.exports = f;
}]);